import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { SalaryMaster } from "../types/salaryMaster";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { AppDispatch } from "../redux/store";
import Select from "react-select";
import "../styles/Form.css";
import { fetchEmployeesAction } from "../redux/actions/employeeActions";

interface Props {
  initialData?: SalaryMaster | null;
  onSave: (data: SalaryMaster) => void;
  salaries: SalaryMaster[];
}
const SalaryMasterForm: React.FC<Props> = ({
  initialData,
  onSave,
  salaries,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [formData, setFormData] = useState<SalaryMaster>({
    id: initialData?.id ?? 0,
    employeeId: initialData?.employeeId ?? "",
    gross: initialData?.gross ?? 0,
    basicPay: initialData?.basicPay ?? 0,
    hra: initialData?.hra ?? 0,
    tax: initialData?.tax ?? 0,
    pf: initialData?.pf ?? 0,
    ta: initialData?.ta ?? 0,
    sa: initialData?.sa ?? 0,
  });
  const employees = useSelector((state: StoreState) => state.employee);
  const [selectedEmployeeOption, setSelectedEmployeeOption] =
    useState<SelectOption | null>(null);
  type SelectOption = {
    label: string;
    value: string;
  };
  useEffect(() => {
    dispatch(fetchEmployeesAction());
  }, [dispatch]);

  useEffect(() => {
    if (initialData && initialData.employeeId && employees.length > 0) {
      const selected = employees.find(
        (emp) => emp.employeeId === initialData.employeeId,
      );
      if (selected) {
        setSelectedEmployeeOption({
          label: selected.employeeId,
          value: selected.id.toString(),
        });
      }
    }
  }, [initialData, employees]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: Number(value) });
  };

  const handleGrossChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);

    const basic = value * 0.4;
    const hra = basic * 0.5;
    const otherTa = hra * 0.5;
    const special = value - basic - hra - otherTa;
    const pf = basic * 0.12;
    setFormData((prev) => ({
      ...prev,
      gross: value,
      basicPay: parseFloat(basic.toFixed(2)),
      hra: parseFloat(hra.toFixed(2)),
      ta: parseFloat(otherTa.toFixed(2)),
      sa: parseFloat(special.toFixed(2)),
      pf: parseFloat(pf.toFixed(2)),
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };
  const preventScroll = (e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  };
  const salaryMasterEmployee = employees.filter((emp) => {
    if (initialData) {
      return (
        emp.employeeId === initialData.employeeId ||
        !salaries.some((s) => s.employeeId === emp.employeeId)
      );
    }
    return !salaries.some((s) => s.employeeId === emp.employeeId);
  });

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-1">
        <Col className="form-column">
          <Form.Group controlId="employeeId">
            <Form.Label>Employee ID</Form.Label>
            <Select
              options={salaryMasterEmployee.map((emp) => ({
                label: `${emp.employeeId}`,
                value: emp.id.toString(),
              }))}
              value={selectedEmployeeOption}
              placeholder="Select Employee ID"
              onChange={(selectedOption) => {
                setSelectedEmployeeOption(selectedOption as SelectOption);
                setFormData((prev) => ({
                  ...prev,
                  employeeId: selectedOption
                    ? (selectedOption as SelectOption).label
                    : "",
                }));
              }}
            />
          </Form.Group>
        </Col>
        <Col className="form-column">
          <Form.Group controlId="basicPay">
            <Form.Label>Gross</Form.Label>
            <Form.Control
              type="text"
              name="gross"
              value={formData.gross}
              onChange={handleGrossChange}
              onWheel={preventScroll}
              inputMode="numeric"
              required
            />
          </Form.Group>
        </Col>
        <Col className="form-column">
          <Form.Group controlId="basicPay">
            <Form.Label>Basic Pay</Form.Label>
            <Form.Control
              type="text"
              name="basicPay"
              value={formData.basicPay}
              readOnly
              onWheel={preventScroll}
              inputMode="numeric"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-1">
        <Col className="form-column">
          <Form.Group controlId="hra">
            <Form.Label>HRA</Form.Label>
            <Form.Control
              type="text"
              name="hra"
              value={formData.hra}
              readOnly
              onWheel={preventScroll}
              inputMode="numeric"
            />
          </Form.Group>
        </Col>
        {/* <Col className="form-column">
          <Form.Group controlId="tax">
            <Form.Label>Tax</Form.Label>
            <Form.Control
              type="text"
              name="tax"
              value={formData.tax}
              onChange={handleChange}
              onWheel={preventScroll}
              inputMode="numeric"
            />
          </Form.Group>
        </Col> */}
        <Col className="form-column">
          <Form.Group controlId="pf">
            <Form.Label>PF</Form.Label>
            <Form.Control
              type="text"
              name="pf"
              value={formData.pf}
              readOnly
              onWheel={preventScroll}
              inputMode="numeric"
            />
          </Form.Group>
        </Col>
        <Col className="form-column">
          <Form.Group controlId="ta">
            <Form.Label>Other Allowance</Form.Label>
            <Form.Control
              type="text"
              name="ta"
              value={formData.ta}
              readOnly
              onWheel={preventScroll}
              inputMode="numeric"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-1">
        <Col className="form-column">
          <Form.Group controlId="sa">
            <Form.Label>SA</Form.Label>
            <Form.Control
              type="text"
              name="sa"
              value={formData.sa}
              readOnly
              onWheel={preventScroll}
              inputMode="numeric"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md={12}>
          <div className="form-buttons">
            <Button type="submit" className="btn-save">
              {initialData ? "Update Salary" : "Add Salary"}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default SalaryMasterForm;
